define('SageDotCom/PatternAnimations/verticalCarousel',[
    "ScrollMagic",
    "TweenMax",
    "ScrollToPlugin",
    "AnimationPlugin",
    "jquery"
], function(ScrollMagic, TweenMax, ScrollToPlugin, AnimationPlugin, $) {
    var scroller = {
        backgrounds: {},
        images: {},
        container: '',
        controller: '',
        navigation: '',
        panes: {},
        scrollHeight: '',
        viewportHeight: '',
        viewportWidth: '',
        paneHeight: '',
        tablet: '600',
        activeClass: ' active',
        buttonClass: 'vertical_carousel__nav'
    };


    function buildSlide() {

        for (var i = 0; i < scroller.panes.length; i++) {
            new ScrollMagic.Scene({
                triggerElement: scroller.panes[i],
                triggerHook: 0,
                offset: 0,
                duration: scroller.paneHeight
            })
                .addTo(scroller.controller);
        }
    }

    function sortSlideContent() {

        for (var i = 0; i < scroller.panes.length; i++) {
            var content = scroller.panes[i].querySelector('.score-center'),
                pin = scroller.panes[i].querySelector('.score-style-box'),
                tweenFadeIn = new TimelineMax(),
                tweenFadeOut = new TimelineMax(),
                tweenBackground = new TimelineMax();

            tweenBackground.to(pin, 0.15, {
                opacity: 1, onCompleteParams: [i], onComplete: function (i) {
                    sortBackground(i + 1)
                }, onReverseCompleteParams: [i], onReverseComplete: function (i) {
                    sortBackground(i - 1)
                }
            });

            if (scroller.viewportWidth > scroller.tablet) {
                tweenFadeIn.fromTo(content, 0.25, { opacity: 0 }, {
                    opacity: 1, onCompleteParams: [i], onComplete: function (i) {
                        sortNavigation(i, true);
                    }, onReverseCompleteParams: [i], onReverseComplete: function (i) {
                        sortNavigation(i, false);
                    }
                });

                new ScrollMagic.Scene({
                    triggerElement: scroller.panes[i],
                    duration: scroller.viewportHeight / 2,
                    offset: 0,
                    triggerHook: 0.6
                })
                    .setTween(tweenFadeIn)
                    .addTo(scroller.controller);
            }

            new ScrollMagic.Scene({
                triggerElement: scroller.panes[i],
                duration: scroller.viewportHeight,
                triggerHook: 0.4
            })
                .setTween(tweenBackground)
                .addTo(scroller.controller);

            if (scroller.viewportWidth > scroller.tablet) {
                tweenFadeOut.to(content, 0.15, { opacity: 0 });
                new ScrollMagic.Scene({
                    triggerElement: content,
                    duration: scroller.viewportHeight / 2,
                    triggerHook: 0.1
                })
                    .setTween(tweenFadeOut)
                    .addTo(scroller.controller);
            }
        }
    }

    function navigateTo(target) {
        scroller.controller.scrollTo(function (target) {
            TweenMax.to(window, 0.5, { scrollTo: { y: target } });
        });
        scroller.controller.scrollTo(target)
    }

    function buildNavigation() {
        for (var i = 0; i < scroller.panes.length; i++) {

            var anchor = document.createElement('a'),
                link = '#' + i;
            anchor.setAttribute('href', link);
            anchor.className = scroller.buttonClass;
            anchor.addEventListener('click', function (e) {
                e.preventDefault();
                var id = this.getAttribute('href').replace('#', '');

                for (var i = 0; i < scroller.panes.length; i++) {
                    if (scroller.panes[i].dataset.screen == id) {
                        navigateTo(scroller.panes[i]);
                    }
                }
            });
            scroller.navigation.appendChild(anchor);
            if (scroller.panes[i]) {
                scroller.panes[i].dataset.screen = i;
            } else {
                scroller.panes[0].dataset.screen = 0;
            }
        }
        scroller.navigation.children[0].className += scroller.activeClass;
    }

    function sortNavigation(button, forward) {
        var numberOfButtons = scroller.navigation.children.length;
        for (var i = 0; i < numberOfButtons; i++) {
            if (scroller.navigation.children[i].className.includes('active')) {
                scroller.navigation.children[i].className = scroller.buttonClass;
            }
            if (forward) {
                if (button < numberOfButtons) {
                    scroller.navigation.children[button].className += scroller.activeClass;
                } else {
                    scroller.navigation.children[numberOfButtons].className += scroller.activeClass;
                }
            } else {
                if (button > 0) {
                    scroller.navigation.children[button - 1].className += scroller.activeClass;
                } else {
                    scroller.navigation.children[0].className += scroller.activeClass;
                }
            }
        }
    }

    function sortBackground(image) {
        for (var i = 1; i < scroller.backgrounds.length; i++) {
            if (image < 0) {
                scroller.backgrounds[i].setAttribute('style', scroller.images[0]);
            } else if (image == scroller.backgrounds.length - 1) {
                scroller.backgrounds[i].setAttribute('style', scroller.images[scroller.backgrounds.length - 2]);
            } else {
                scroller.backgrounds[i].setAttribute('style', scroller.images[image]);
            }
        }
    }

    function buildVerticalCarousel() {
        scroller.scrollHeight = scroller.panes.length * window.innerHeight;
        scroller.viewportHeight = window.innerHeight;
        scroller.viewportWidth = window.innerWidth;
        scroller.paneHeight = scroller.panes[0].offsetHeight;
        buildSlide();
        sortSlideContent();
    }

    return {
        init: function (ScrollMagicController) {
            var patternAnimations = document.querySelectorAll('.sage-pattern-animation__vertical-carousel');

            $.each(patternAnimations, function (patternAnimation) {

                scroller.panes = patternAnimation.querySelectorAll('.container');
                scroller.navigation = patternAnimation.querySelector('.score-style-box');
                scroller.backgrounds = patternAnimation.querySelectorAll('.score-stripe > .score-style-box');

                for (var i = 1; i < scroller.backgrounds.length; i++) {
                    scroller.images[i - 1] = scroller.backgrounds[i].getAttribute('style');
                }
                scroller.controller = ScrollMagicController;
                buildVerticalCarousel();
                buildNavigation();
                sortBackground(0);


                window.addEventListener('resize', buildVerticalCarousel, false);
            });

        }
    }
});

